<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div *ngIf="insertionMessage != null" class="progress-message">
        <span *ngIf="isInserting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ insertionMessage }}
    </div>
    <div *ngIf="formatError" class="alert alert-danger">
        <p>
            The format of the imported data is incorrect. Expected columns:
            <strong>name, employeeName, chargeName, chargeAmount</strong> (required) and optionally
            <strong>description, startDate, recurring</strong>.
        </p>
    </div>
    <div class="table-responsive" *ngIf="displayTable">
        <table *ngIf="!formatError" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <input type="checkbox" (change)="toggleSelectAll($event.target.checked)"
                        [checked]="selectedItems.length === importedData.length && importedData.length > 0">
                </th>
                <td mat-cell *matCellDef="let item">
                    <input type="checkbox" (change)="onCheckboxChange(item, $event.target.checked)"
                        [checked]="isSelected(item)">
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let item">{{ item.name }}</td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let item">{{ item.description }}</td>
            </ng-container>

            <ng-container matColumnDef="employeeName">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Employee</th>
                <td mat-cell *matCellDef="let item">{{ item.employeeName }}</td>
            </ng-container>

            <ng-container matColumnDef="chargeName">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Charge</th>
                <td mat-cell *matCellDef="let item">{{ item.chargeName }}</td>
            </ng-container>

            <ng-container matColumnDef="chargeAmount">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Amount</th>
                <td mat-cell *matCellDef="let item">{{ item.chargeAmount }}</td>
            </ng-container>

            <ng-container matColumnDef="startDate">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Start Date</th>
                <td mat-cell *matCellDef="let item">{{ item.startDate }}</td>
            </ng-container>

            <ng-container matColumnDef="recurring">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Recurring</th>
                <td mat-cell *matCellDef="let item">{{ item.recurring }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator *ngIf="!formatError" [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div class="modal-footer large-modal" *ngIf="!isImported">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate" [disabled]="formatError" type="button" class="btn btn-primary"
        (click)="saveSelectedItems()">
        Save
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Save <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
</div>
